webpackJsonp([12],{

/***/ 713:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_Grid__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_Paper__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_Paper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_Paper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_Typography__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_Typography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_styles__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_material_ui_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_Divider__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_Divider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_material_ui_Divider__);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }










var styleSheet = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_material_ui_styles__["createStyleSheet"])("Api", function (theme) {
  var _ref;

  return _ref = {
    row: {
      padding: "10px 20px",
      "& h3": {
        fontSize: "16px",
        lineHeight: "24px"
      }
    }
  }, _defineProperty(_ref, theme.breakpoints.up("md"), {
    row: {
      "& h3": {
        fontSize: "24px",
        lineHeight: "32px"
      }
    }
  }), _defineProperty(_ref, "cellHeader", {
    fontWeight: "bold",
    fontSize: 16,
    minWidth: 350,
    maxWidth: 350
  }), _defineProperty(_ref, "apiList", {
    listStyleType: "none",
    margin: 0,
    padding: "0 0 0 16px",
    "& li": {
      fontSize: 16,
      marginBottom: 15,
      "& ul": {
        listStyleType: "none",
        paddingLeft: 20
      },
      "& li": {
        marginBottom: 10,
        fontSize: 14
      }
    },
    "& code": {
      fontSize: 12
    }
  }), _ref;
});

var authInfo = [{
  name: "X-Prerender-Token",
  messages: [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "code",
    null,
    "curl --header \"X-Prerender-Token: secret-token\""
  )]
}];

var optionalHeaders = [];

var renderApiInfo = function renderApiInfo(apiFeatures, props) {
  return apiFeatures.map(function (apiFeature, i) {
    if (apiFeature.isSubtitle) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { key: i },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_material_ui_Grid___default.a,
          { container: true, className: props.classes.row },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_material_ui_Grid___default.a,
            { item: true, xs: 12, sm: 12, className: props.classes.cellHeader },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "h4",
              { style: { margin: 0 } },
              apiFeature.title
            )
          )
        )
      );
    }
    var messages = apiFeature.messages.map(function (message, i) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "li",
        { key: i },
        message
      );
    });
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { key: i },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_material_ui_Grid___default.a,
        { container: true, className: props.classes.row },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_material_ui_Grid___default.a,
          { item: true, xs: 12, sm: 12, className: props.classes.cellHeader },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "code",
            null,
            apiFeature.name
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_material_ui_Grid___default.a,
          { item: true, xs: 12, sm: true },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "ul",
            { className: props.classes.apiList },
            messages
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_Divider___default.a, null)
    );
  });
};

var Api = function Api(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2_material_ui_Grid___default.a,
      { container: true },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_material_ui_Grid___default.a,
        { item: true, xs: 12 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_material_ui_Paper___default.a,
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_material_ui_Grid___default.a,
            { container: true, className: props.classes.row },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_material_ui_Grid___default.a,
              { item: true, xs: 12 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "p",
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "strong",
                  null,
                  "Endpoint:"
                ),
                " ",
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "code",
                  null,
                  "service.headless-render-api.com/api/v1"
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "p",
                null,
                "This administrative API is for operations related to your account, see the ",
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Link */],
                  { to: "/docs/api" },
                  "pre-rendering API"
                ),
                " ",
                "for documenation on pre-rendering and screenshots."
              )
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "h2",
          null,
          "Auth"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_material_ui_Paper___default.a,
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_material_ui_Grid___default.a,
            { container: true, className: props.classes.row },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_material_ui_Grid___default.a,
              { item: true, xs: 12 },
              "Your API token via HTTP header is required for any administrative API commands (unlike the pre-rendering API)"
            )
          ),
          renderApiInfo(authInfo, props)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "h2",
          null,
          "Clearing server cache"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "p",
          null,
          "By default, headless-render-api.com caches for 5 minutes. This is configurable for each API request (see the",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "code",
            null,
            "Prerender-Cache-Duration"
          ),
          " header in the",
          " ",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Link */],
            { to: "/docs/api" },
            "pre-rendering API docs"
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "p",
          null,
          "This ",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "code",
            null,
            "POST"
          ),
          " request will clear headless-render-api.com's cache for URLs hit by your account. Some headless-render-api.com users set their ",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "code",
            null,
            "Prerender-Cache-Duration"
          ),
          " value to long periods (e.g. 1 month) and sometimes want an easy way to clear all cache."
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_material_ui_Paper___default.a,
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_material_ui_Grid___default.a,
            { container: true, className: props.classes.row },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_material_ui_Grid___default.a,
              { item: true, xs: 12 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4_material_ui_Typography___default.a,
                { type: "subheading" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "strong",
                  null,
                  "POST"
                ),
                " ",
                "https://service.headless-render-api.com/api/v1/clear-cache"
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "code",
                null,
                "curl -XPOST -H'X-Prerender-Token: SECRET_API_TOKEN' http://service.headless-render-api.com/api/v1/clear-cache"
              )
            )
          )
        )
      )
    )
  );
};

/* harmony default export */ __webpack_exports__["default"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_material_ui_styles__["withStyles"])(styleSheet)(Api));

/***/ })

});


// WEBPACK FOOTER //
// static/js/12.16e3fa99.chunk.js